import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap} from "gsap";
import {KennethMustDie} from "../../KennethMustDie";

export class KMDAvalancheBetPresentation implements FlowStatePresentation {

    public start(flowStateController: FlowStateController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                flowStateController.finish();
            }
        });

        tl.add(() => {
            KennethMustDie.reelView.toggleMask(true);
            KennethMustDie.specialReelView.toggleMask(true);
        }, 0);

        tl.to(this, {
            duration: 0.7 // #224
        });
    }
}